/**
 * Space under page content so it never sits flush with the bottom of the screen,
 * including the iOS home indicator. 2.5rem, plus the safe-area inset.
 */
export const appBottomClearanceClass = "pb-[calc(2.5rem+env(safe-area-inset-bottom,0px))]";

/**
 * Public questionnaire column height inside that clearance.
 * Top padding is 1rem (md: 1.5rem); bottom is the shared 2.5rem plus the safe area.
 */
export const publicFormColumnMinHeightClass =
    "min-h-[calc(100dvh-3.5rem-env(safe-area-inset-bottom,0px))] md:min-h-[calc(100dvh-4rem-env(safe-area-inset-bottom,0px))]";

export const publicFormColumnHeightClass =
    "h-[calc(100dvh-3.5rem-env(safe-area-inset-bottom,0px))] md:h-[calc(100dvh-4rem-env(safe-area-inset-bottom,0px))]";
